<div [hidden]="onOff === true" [innerHTML]="scryptLite.iframeScriptContent[this.item.uId]"></div>

<div
  [hidden]="!!scryptLite.iframeScriptContent[this.item.uId]"
  #myDiv
  [attr.class]="divAttributes.class"
  [attr.data-form]="divAttributes.dataForm"
></div>

<div
  [hidden]="onOff === false"
  #myDiv2
  [attr.class]="divAttributes.class"
  [attr.data-form]="divAttributes.dataForm"
></div>
